// Module
var code = "<div class=quill-parent tabindex=40><div class=quill-editor></div></div>";
// Exports
module.exports = code;